import { useMemo } from 'react';

import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import { useDataWithPublicUser } from '../../../services/User/useDataWithPublicUser';
import { convertToBidder } from '../utils/bidderConverter';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { BidderDto } from '../utils/bidderTypes';

export const useBiddersList = (auction?: AuctionDto, technicalUser?: UserDetailsDto) => {
  const { data, ...other } = useDataWithPublicUser(auction?.bids || []);

  const bidders = useMemo(() => {
    const bidders = convertToBidder(data, auction);
    const adjustedBidders: BidderDto[] = bidders.map(bidder => ({
      ...bidder,
      firstName: technicalUser ? technicalUser.firstName : bidder.firstName,
      lastName: technicalUser ? technicalUser.lastName : bidder.lastName,
    }));

    return adjustedBidders;
  }, [data, technicalUser?.firstName, technicalUser?.lastName]);

  return { bidders, ...other };
};
